import '../assets/styles/sideBar.css';
import { ReactComponent as FileIcon } from "../assets/img/Icon awesome-file-upload.svg";
import { ReactComponent as EnginnerIcon } from "../assets/img/engenheiro.svg";
import { ReactComponent as InsumosLogo } from "../assets/images/campo.svg";
import { ReactComponent as CoinLogo } from "../assets/img/moedas-de-dolar.svg";
import { ReactComponent as ApolloIcon } from "../assets/img/Apollo Icon 1.svg";
import { Link } from 'react-router-dom';
import React from 'react';

export const SideBar = () => {

    const [activeIndex, setActiveIndex] = React.useState(0);

    const handleClick = (index) => {
        setActiveIndex(index);
        const rows = document.querySelectorAll('.content-row-side');
        rows.forEach((row, i) => {
            if (i === index) {
                row.classList.add('side-active');
            } else {
                row.classList.remove('side-active');
            }
        });
    };

    const items = [
        { text: 'Obras', link: '/' },
        { text: 'Insumos', link: '/insumos' },
        { text: 'Atualizar Planilhas', link: '/update' },
        { text: 'Moedas', link: '/moedas' },
        { text: 'Atlas', link: '/refresh' }
    ];
    const components = [
        <EnginnerIcon />,
        <InsumosLogo />,
        <FileIcon />,
        <CoinLogo />,
        <ApolloIcon />
    ]

    return (
        <section className='body-side-bar'>
            <nav className='side-bar-area'>
                <div className='logoScala-container' />
                <span className='sidebar-name'>Sistema Apollo</span>
                {items.map((item, index) => (
                    <Link key={index}
                        className={activeIndex === index ? 'side-active content-row-side' : 'content-row-side'}
                        onClick={() => handleClick(index)} to={item.link}>
                        {
                            components[index]
                        }
                        <h3 className='montserrat'>{item.text}</h3>
                        <div className={activeIndex === index ? 'border-active-side' : 'hidden-border-side'} />
                    </Link>
                ))}
                <div className='logoFooter' />
            </nav>
        </section >
    )
}